import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ApiDocumentComponent } from './api-document/api-document.component';
import { HomeComponent } from './home/home.component';
import { NotificationEngineComponent } from './notification-engine/notification-engine.component';
import { SubscriptionDashboardComponent } from './notification-engine/subscription-dashboard/subscription-dashboard.component';
import { UserListComponent } from './notification-engine/user-list/user-list.component';
import { CreateSupplierProfileDetailComponent } from './supplier-profile/create-supplier-profile-detail/create-supplier-profile-detail.component';
import { CreateSupplierProfileComponent } from './supplier-profile/create-supplier-profile/create-supplier-profile.component';
import { SupplierProfileComponent } from './supplier-profile/supplier-profile.component';
import { ViewSupplierProfileDetailComponent } from './supplier-profile/view-supplier-profile-detail/view-supplier-profile-detail.component';
import { ViewSupplierProfileComponent } from './supplier-profile/view-supplier-profile/view-supplier-profile.component';

const isIframe = window !== window.parent && !window.opener;

const routes: Routes = [
  {
    path: 'supplier-profile',
    component: SupplierProfileComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'supplier-profile/create-supplier-profile',
    component: CreateSupplierProfileComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'supplier-profile/:supplier-identity',
    component: ViewSupplierProfileComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'supplier-profile/:supplier-identity/create-detail',
    component: CreateSupplierProfileDetailComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'supplier-profile/:supplier-identity/:vendor-plan',
    component: ViewSupplierProfileDetailComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'notification-engine',
    component: NotificationEngineComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'notification-engine/admin',
    component: SubscriptionDashboardComponent,
    children: [
      {
        path: '',
        component: UserListComponent,
      },
      {
        path: ':eventName',
        component: UserListComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'api-document',
    component: ApiDocumentComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'code',
    component: HomeComponent,
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    redirectTo: '',
    canActivate: [MsalGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
